module.exports = __webpack_public_path__ + "img/carrefour-estrie.695625dd.svg";